package com.eladfinish.bible.contest.screens.openQuestions.usecases

import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.di.config.DebugInfo
import com.eladfinish.bible.contest.network.spreadsheet.GoogleSheetRowHeadersAndValues
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApi
import com.eladfinish.bible.contest.network.spreadsheet.handleApiResult
import com.eladfinish.bible.contest.network.spreadsheet.toSpreadsheetMatrixWithHeaders
import com.eladfinish.bible.contest.screens.openQuestions.NO_TOPICS_ERROR
import com.eladfinish.bible.contest.screens.openQuestions.model.TopicItem
import com.eladfinish.bible.contest.screens.openQuestions.model.TopicItemEntry
import com.eladfinish.bible.contest.screens.openQuestions.model.toTopicItemEntries
import com.eladfinish.bible.contest.screens.openQuestions.model.toTopicItems
import com.eladfinish.bible.contest.utils.spreadsheet.getId
import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.single
import kotlinx.serialization.json.Json

class GetTopicsUseCase(
    private val spreadsheetApi: SpreadsheetApi,
    private val debugInfo: DebugInfo,
) {

    suspend operator fun invoke(): Result<String> =
        spreadsheetApi.getDataFromSpreadsheet(spreadsheetId = Constants.google_spreadsheet_open_questions_topics.getId())
            .handleApiResult { result ->
                result.data
                    .toSpreadsheetMatrixWithHeaders()
                    .map { list: List<GoogleSheetRowHeadersAndValues> -> list.toTopicItemEntries() }
                    .map { items: List<TopicItemEntry> ->

                        if (items.isEmpty()) {
                            val throwable = Throwable(NO_TOPICS_ERROR)
                            AppCrashlytics.logException(throwable)
                            return@map Result.failure(throwable)
                        }

                        // only I can see personal topics
                        val topicItems = items.toTopicItems(includePersonal = debugInfo.isDebugMode)

                        val topicItemsJsonAsString = Json.encodeToString(topicItems)

                        Napier.d("topicItemsJsonAsString:\n${topicItems.joinToString(separator = "\n")}")

                        Result.success(topicItemsJsonAsString)
                    }
                    .single()
            }

}
